import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import { dateTimeFormat } from 'constants/formats';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';

const CertificationViewHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useCommunicationDetailsPage();

  const { communication } = data;

  const certificateId = communication?.certificate?.id || '00746F5K28';

  return (
    <div className="nk-block-head m-0">
      <div className="nk-block-between g-3">
        <div className="nk-block-head-content">
          <div className="nk-block-head-content d-flex justify-content-between">
            <h4 className="title">
              {t('Certificate')}
              <strong className="text-primary small ml-2">
                #{certificateId}
              </strong>
            </h4>

            <ul className="d-flex g-1">
              <li className="">
                {/* <ReactToPrint
                      trigger={() => (
                        <span className="btn btn-icon btn-trigger btn-tooltip">
                          <em className="icon ni ni-printer" />
                        </span>
                      )}
                      // content={() => printRef.current}
                      documentTitle={`Certificado - ${certificateId} - ${format(
                        new Date(),
                        'dd-MM-yyyy'
                      )}`}
                    /> */}
              </li>
            </ul>
          </div>

          <p className="heading">{t('SttokCertifies')}:</p>
          <p className="heading text-justify">{t('CertificationMessage')}</p>

          <div className="nk-block-des text-soft">
            <ul className="list-inline">
              <li>
                <span className="text-base">
                  <b>{t('GeneratedCertificate')}:</b>{' '}
                  {format(new Date(), dateTimeFormat)}
                </span>
              </li>
              <li>
                <span className="text-base">
                  <b>{t('Certificate')} Nº:</b> #{certificateId}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificationViewHeader;
